/** Golf Rate Plan (Transactions) — payload keys / excel columns. */

export const GOLF_RATE_PLAN_FIELD_COURSES = "Courses";
export const GOLF_RATE_PLAN_FIELD_RATE_TYPE = "RateType";
export const GOLF_RATE_PLAN_FIELD_START_DATE = "StartDate";
export const GOLF_RATE_PLAN_FIELD_END_DATE = "EndDate";
export const GOLF_RATE_PLAN_FIELD_START_TIME = "StartTime";
export const GOLF_RATE_PLAN_FIELD_END_TIME = "EndTime";
export const GOLF_RATE_PLAN_FIELD_AVAILABLE_DAYS = "AvailableDaysOfWeek";
export const GOLF_RATE_PLAN_FIELD_GREEN_FEE = "GreenFee";
export const GOLF_RATE_PLAN_FIELD_CART_FEE = "CartFee";
export const GOLF_RATE_PLAN_FIELD_GREEN_FEE_RETAIL_ITEM = "GreenFeeRetailItem";
export const GOLF_RATE_PLAN_FIELD_CART_FEE_RETAIL_ITEM = "CartFeeRetailItem";
export const GOLF_RATE_PLAN_FIELD_ENTRY_FEE = "EntryFee";
export const GOLF_RATE_PLAN_FIELD_ENTRY_FEE_RETAIL_ITEM = "EntryFeeRetailItem";

export const golfRatePlanValidationMessages = {
  mandatory:
    "Courses, Rate Type, Start Date, End Date, Green Fee, Green Fee Retail Item, and at least one Available Day are mandatory",
  availableDaysNotCovered:
    "Selected available days must occur at least once between Start Date and End Date. The date range does not cover one or more selected days of the week.",
  endDateBeforeStart: "End Date cannot be before Start Date",
  atLeastOneDay: "Select at least one available day of the week",
};
